import { makeStyles, Tooltip } from '@material-ui/core';
import { AccessTime, Error, Schedule } from '@material-ui/icons';
import React from 'react';

const classStyle = makeStyles(() => ({
  canceled: {
    height: '19px',
    fontFamily: 'Muli',
    fontSize: '14px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    textAlign: 'right',
    color: '#e88e18',
  },
  statusCard: {
    height: '20px',
    cursor: 'pointer',
    textAlign: 'right !important',
  },
}));

const getIcon = (icon) => {
  if (icon === 'error') return <Error style={{ color: '#f00', width: '18px' }} />;
  if (icon === 'errorEmissao') return <Error style={{ color: '#b53838', width: '18px' }} />;
  if (icon === 'cancel') return <Error style={{ color: '#e88e18', width: '18px' }} />;
  if (icon === 'schedule') return <Schedule style={{ color: '#e88e18', width: '18px' }} />;
  if (icon === 'clock') return <AccessTime style={{ color: '#5890AA', width: '18px' }} />;
};

export const InfoButton = ({ title, id, icon, onClick }) => {
  const style = classStyle();
  return (
    <Tooltip title={title}>
      {icon === 'canceled' ? (
        <div className={style.canceled} onClick={(e) => onClick(id)}>
          {title}
        </div>
      ) : (
        <div title={title} className={style.statusCard} onClick={(e) => onClick(id)}>
          {getIcon(icon)}
        </div>
      )}
    </Tooltip>
  );
};
